import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_site",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = { class: "d-flex flex-stack" }
const _hoisted_10 = { class: "me-5" }
const _hoisted_11 = { class: "fs-5 fw-bold" }
const _hoisted_12 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_13 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_14 = { class: "fv-row mb-5" }
const _hoisted_15 = { class: "d-flex flex-stack" }
const _hoisted_16 = { class: "me-5" }
const _hoisted_17 = { class: "fs-5 fw-bold" }
const _hoisted_18 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_19 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_20 = { class: "modal-footer flex-center" }
const _hoisted_21 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_22 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.siteData,
          ref: "addSiteForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t("message.ADD")} ${_ctx.$t("message.SITE")}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: "text",
                  name: "name",
                  label: _ctx.$t('message.NAME'),
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                  requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.siteData.name = $event)),
                  target: "name",
                  required: true,
                  value: _ctx.siteData.name
                }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"]),
                _createVNode(_component_Input, {
                  type: "text",
                  name: "account_id",
                  label: _ctx.$t('message.ACCOUNT_ID'),
                  account_id: _ctx.siteData.account_id,
                  "onUpdate:account_id": _cache[2] || (_cache[2] = ($event: any) => (_ctx.siteData.account_id = $event)),
                  target: "account_id",
                  value: _ctx.siteData.account_id
                }, null, 8, ["label", "account_id", "value"]),
                _createVNode(_component_Select, {
                  name: "type",
                  label: _ctx.$t('message.SELECT'),
                  target: "type",
                  type: _ctx.siteData.type,
                  "onUpdate:type": _cache[3] || (_cache[3] = ($event: any) => (_ctx.siteData.type = $event)),
                  requiredMsg: `${_ctx.$t('message.TYPE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  required: true,
                  selectData: _ctx.type,
                  value: _ctx.siteData.type,
                  clearable: true
                }, null, 8, ["label", "type", "requiredMsg", "selectData", "value"]),
                _createVNode(_component_Select, {
                  name: "country_id",
                  target: "country_id",
                  label: _ctx.$t('message.COUNTRIES'),
                  required: true,
                  filterable: true,
                  placeholder: _ctx.$t('message.SELECT'),
                  country_id: _ctx.siteData.country_id,
                  "onUpdate:country_id": _cache[4] || (_cache[4] = ($event: any) => (_ctx.siteData.country_id = $event)),
                  selectData: _ctx.countries,
                  value: _ctx.siteData.country_id,
                  callEmit: true,
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeConfig(_ctx.siteData.country_id))),
                  clearable: true
                }, null, 8, ["label", "placeholder", "country_id", "selectData", "value"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("message.STATUS")), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(`${_ctx.$t("message.SITE")} ${_ctx.$t("message.ACTIVATE_AND_DEACTIVATE")}`), 1)
                  ]),
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.siteData.status,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.siteData.status = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("label", _hoisted_17, _toDisplayString(`${_ctx.$t("message.PRICE")} ${_ctx.$t("message.WITH")} ${_ctx.$t("message.TAX")}`), 1),
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("message.SHOW_ALL_PRICES_WITH_TAX_IN_SHOP")), 1)
                  ]),
                  _createVNode("span", _hoisted_19, [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.siteData.prices_with_tax,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.siteData.prices_with_tax = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("button", _hoisted_21, _toDisplayString(_ctx.$t("message.CANCEL")), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}